import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";

import DiasFeriados from './DiasFeriados';
import DiasInscripcion from './DiasInscripcion';
import { PreferenciasAdmin, GuardarFecha } from "../../funciones/PreferenciasAdminFunction";
import CarrerasUsu from './CarrerasUsu';


class OptionContent1 extends Component {
    state = {
        diasClaseOff: [],
        lun: false,
        mar: false,
        mie: false,
        jue: false,
        vie: false,
        sab: false,
        dom: false,
        boton1:{
            icon: "fa fa-save",
            text: "Guardar Cambios",
            disabled: false
        },
        cantErrores: "",
        carreras: [],
        preloaderC: <div><i className = "fa fa-spinner fa-spin"></i> Buscando Carreras</div>
    }

    componentDidMount = () => {
        PreferenciasAdmin ((resp) => {
            let dias = [];
            if (resp[1].Sun === 0) dias.push(0);
            if (resp[1].Mon === 0) dias.push(1);
            if (resp[1].Tue === 0) dias.push(2);
            if (resp[1].Wed === 0) dias.push(3);
            if (resp[1].Thu === 0) dias.push(4);
            if (resp[1].Fri === 0) dias.push(5);
            if (resp[1].Sat === 0) dias.push(6);

            this.setState({
                diasClaseOff: dias,
                dom: resp[1].Sun,
                lun: resp[1].Mon,
                mar: resp[1].Tue,
                mie: resp[1].Wed,
                jue: resp[1].Thu,
                vie: resp[1].Fri,
                sab: resp[1].Sat,
                carreras: resp[5]
            })
        })
    }

    cambiaSwitch = (prop) => {
        this.setState({
            [prop]: !this.state[prop]
        })
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            this.setState({
                boton1:{
                    icon: "fa fa-save",
                    text: "Guardar Cambios"
                },
            }, () => {
                PreferenciasAdmin ((resp) => {
                    let dias = [];
                    if (resp[1].Sun === 0) dias.push(0);
                    if (resp[1].Mon === 0) dias.push(1);
                    if (resp[1].Tue === 0) dias.push(2);
                    if (resp[1].Wed === 0) dias.push(3);
                    if (resp[1].Thu === 0) dias.push(4);
                    if (resp[1].Fri === 0) dias.push(5);
                    if (resp[1].Sat === 0) dias.push(6);
        
                    this.setState({
                        dom: resp[1].Sun,
                        lun: resp[1].Mon,
                        mar: resp[1].Tue,
                        mie: resp[1].Wed,
                        jue: resp[1].Thu,
                        vie: resp[1].Fri,
                        sab: resp[1].Sat,
                        diasClaseOff: dias
                    })
                })

                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }
        
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    contenido = () => {
        let { diasClaseOff, lun, mar, mie, jue, vie, sab, dom, boton1, carreras, preloaderC } = this.state;

        const campos = { lun, mar, mie, jue, vie, sab, dom }

        const styles = {
            padding: 2, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 12
        }

        let activarUsu = () => {
            if (carreras.length === 0 ) return (
                <tr>
                    <td colSpan={2} align="center">{preloaderC}</td>
                </tr>
            )

            return(
                carreras.map(option => (
                    <CarrerasUsu id = {option.id} data = {option}/>
                ))
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">Dias Feriados y no Laborables</div>
                <DiasFeriados DiasOff={diasClaseOff}/>

                <div className="custom-alert-info custom-mt-20">Dias de Clase</div>
                <Row>
                    <Col md={8} className="custom-mt-10">
                        <div className="table-responsive">
                            <Table bordered style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td style={styles} align="center">Dom</td>
                                        <td style={styles} align="center">Lun</td>
                                        <td style={styles} align="center">Mar</td>
                                        <td style={styles} align="center">Mie</td>
                                        <td style={styles} align="center">Jue</td>
                                        <td style={styles} align="center">Vie</td>
                                        <td style={styles} align="center">Sab</td>
                                    </tr>
                                    <tr>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("dom")}} checked={dom} />
                                        </td>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("lun")}} checked={lun} />
                                        </td>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("mar")}} checked={mar} />
                                        </td>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("mie")}} checked={mie} />
                                        </td>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("jue")}} checked={jue} />
                                        </td>
                                        <td style={styles2} align="center">
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("vie")}} checked={vie} />
                                        </td>
                                        <td style={styles2} align="center"> 
                                            <Switch height={12} width={24} onChange={() => {this.cambiaSwitch("sab")}} checked={sab} />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={4} align="right" className="custom-mt-10">
                        <button className="btn btn-primary" onClick={()=> {
                            this.setState({
                                boton1:{
                                    icon:"fa fa-spinner fa-spin",
                                    text: "Espera"
                                }
                            }, () => {
                                GuardarFecha (campos, (resp) => { this.respuestaGuardar(resp) })
                            })
                        }} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </Col>
                </Row>
                <div className="custom-alert-danger custom-mt-20">Activar Inicio de Sesión</div>
                    <Table className = "custom-mt-10" striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr style = {{backgroundColor: "a0555c", color: "fff"}}>
                                <td align="center" width="80%" style={styles}><strong>Carrera</strong></td>
                                <td align="center" colSpan = {2} width="20%" style={styles}><strong>Estatus</strong></td>
                            </tr>
                            {activarUsu()}
                        </tbody>
                    </Table>
                <div className="custom-alert-danger custom-mt-20">Dias de Reinscripción</div>
                <DiasInscripcion DiasOff={diasClaseOff}/>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">En este módulo puedes cambiar las configuraciones del sistema correspondientes a las <strong className="text-primary">Fechas</strong>.</div>
            <div className="custom-alert-info custom-mt-10">Dias Feriados y no Laborables</div>
            <div align="justify" className="custom-mt-10">
                En esta sección tienes dos columnas, en la parte izquierda puedes observar un calendario con fechas seleccionables.
            </div>
            <div align="justify" className="custom-mt-10">
                Para seleccionar un rango de fechas primero haz click en la fecha inicial y luego presiona la fecha final, esto dibuja el rango que has seleccionado
            </div>
            <div align="justify" className="custom-mt-10">
                En la parte derecha puedes ver dos cuadros de texto con la fecha inicial y la fecha final del rango que seleccionaste, ademas del campo <strong>Motivo</strong> el cual debes llenar indicando el motivo del dia no laborable.
            </div>
            <div align="justify" className="custom-mt-10">
                Una vez ingresado el rango de fechas y el motivo, presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-plus"></i> Agregar</button>
            </div>
            <div align="justify" className="custom-mt-10">
                En la parte inferior de esta sección puedes ver una tabla con los <strong>Dias no laborables</strong> registrados. Si presionas el boton <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-trash"></i></button> en la parte derecha de cada dia registrado podrás eliminarlo
            </div>

            <div className="custom-alert-info custom-mt-10">Dias de Clase</div>
            <div align="justify" className="custom-mt-10">
                Aquí puedes elegir los dias de clases disponibles en la semana simplemente activa la opción <Switch height={12} width={24} checked={true}/> y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar Cambios</button> para Actualizar los cambios
            </div>
            <div align="justify" className="custom-mt-10">
                <strong>Nota: para ver el resto de las configuraciones selecciona la <span className="text-primary">OPCION PREFERENCIAS</span> de la parte superior</strong>
            </div>
            <div className="custom-alert-danger custom-mt-10">Dias de Inscripción</div>
            <div align="justify" className="custom-mt-10">
                Aqui puedes seleccionar los dias correspondientes a <strong>Reinscripción</strong> que estarán disponibles para los estudiantes.
            </div>
            <div align="justify" className="custom-mt-10">
                Para asignar los días de reinscripción primero debes <strong>Seleccionar un Periodo</strong> y luego las fechas correspondientes haciendo click en la primera fecha y luego en la última; esto añadirá el rango de fechas para la reinscripción y presiona el botón <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Agregar</button> para guardar las fechas
            </div>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={9}>
                        <div>
                            {this.contenido()}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Configuraciones de Fecha</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default OptionContent1;


// WEBPACK FOOTER //
// ./src/views/Opciones/OptionContent1.jsx